import state from './dashboard.state'
import actions from './dashboard.actions'
import mutations from './dashboard.mutations'

export default {
  state,
  actions,
  mutations
}
